import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import IconButton from 'emerald-ui/lib/IconButton';
import Popover from 'emerald-ui/lib/Popover';
import Button from 'emerald-ui/lib/Button';

import { useThemeStore } from '../../state/themeStore';

function ThemeButton(props) {
  const [newDarkThemeSignShown, setNewDarkThemeSignShown] = useState(false);
  const theme = useThemeStore((state) => state.theme);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);

  useEffect(() => {
    showNewDarkThemeSign();
  }, []);

  function showNewDarkThemeSign() {
    if (!window.localStorage.getItem('emerald-ui-docs-new-dark-theme-shown')) {
      setNewDarkThemeSignShown(false);
    } else {
      setNewDarkThemeSignShown(true);
    }
  }

  function hideNewDarkThemeSign() {
    window.localStorage.setItem('emerald-ui-docs-new-dark-theme-shown', 'true');
    setNewDarkThemeSignShown(true);
  }

  const { style, ...rest } = props;

  return (
    <div {...rest} style={{ position: 'relative', ...style }}>
      <IconButton className="theme-button" onClick={toggleTheme} icon={theme === 'dark' ? 'wb_sunny' : 'nights_stay'} />
      {!newDarkThemeSignShown ? (
        <Popover title="New Dark Mode" placement="bottom" className="new-dark-mode-sign">
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <p style={{ marginBottom: '20px' }}>
              Now you can toggle between the regular (Light) and the new Dark Mode.
            </p>
            <Button onClick={hideNewDarkThemeSign} style={{ alignSelf: 'flex-end' }}>
              Got it
            </Button>
          </div>
        </Popover>
      ) : null}
    </div>
  );
}

ThemeButton.propTypes = {
  darkTheme: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  store: PropTypes.object,
};

export default ThemeButton;
